import React, { PureComponent } from 'react';
import isNull from 'lodash/isNull';
import cx from 'classnames';
import ReactTooltip from 'react-tooltip';
import { Trans, t, defineMessage } from '@lingui/macro';

import sortKeysBy from '../../utils/sortKeysBy';
import { rank } from '../../utils/config';
import styles from './StationOdRank.module.scss';

const buttonMessages = {
    borrow: {
        hide: defineMessage({ id: 'od.hideBorrowButton' }),
        show: defineMessage({ id: 'od.showBorrowButton' }),
    },
    return: {
        hide: defineMessage({ id: 'od.hideReturnButton' }),
        show: defineMessage({ id: 'od.showReturnButton' }),
    }
};

class StationOdRank extends PureComponent {
    handleMouseEnter = (key) => {
        const { type, handleMouseEnterStation } = this.props;
        handleMouseEnterStation(key, type);
    }

    handleMouseLeave = (key) => {
        const { type, handleMouseLeaveStation } = this.props;
        handleMouseLeaveStation(key, type);
    }

    render() {
        const tbody = [];
        let title;
        let flag = 0;
        let tooltip;
        const {
            data,
            totalNum,
            type,
            highlight,
            show,
            showPercent,
            isMobile,
            handleClick,
            geo,
        } = this.props;
        const dataIsNull = isNull(data);
        if (!dataIsNull) {
            const sortKey = sortKeysBy(data);
            for (const i in sortKey) {
                if (sortKey[i]) {
                    const key = sortKey[i];
                    const { station } = geo[key];
                    let highlightClass = false;
                    if (type === highlight.type && key === highlight.dest) highlightClass = true;

                    if (flag < rank) {
                        tbody.push(
                            <tr
                                className={cx('odrank', { highlight: highlightClass })}
                                key={i}
                                onMouseEnter={this.handleMouseEnter.bind(this, key)}
                                onMouseLeave={this.handleMouseLeave.bind(this, key)}
                            >
                                <td className={styles.heatMapTransactionName}>{station}</td>
                                {showPercent ? (
                                    <td>
                                        {`${((this.props.data[key] / totalNum) * 100).toFixed(2)}%`}
                                    </td>
                                ) : (
                                    <td>{this.props.data[key]}</td>
                                )}
                            </tr>,
                        );
                        flag += 1;
                    } else {
                        break;
                    }
                }
            }
        }

        if (type === 'borrow') {
            title = t({ id: 'od.destination' });
            tooltip = t({ id: 'od.tooltip.destination' });
        } else if (type === 'return') {
            title = t({ id: 'od.origin' });
            tooltip = t({ id: 'od.tooltip.origin' });
        }
        const btnClassName = cx('btn', 'btn-default', styles.btnDate, { active: show });
        return (
            <div className="table-responsive">
                {dataIsNull ? (
                    <div>
                        {title}
                        {' '}
                        <Trans id="od.noData" />
                    </div>
                ) : (
                    <div>
                        {!isMobile ? (
                            <button type="button" className={btnClassName} onClick={handleClick}>
                                {show
                                    ? <Trans id={buttonMessages[type].show.id} />
                                    : <Trans id={buttonMessages[type].hide.id} />
                                }
                            </button>
                        ) : null}
                        <table>
                            <thead>
                                <tr>
                                    <th>{title}</th>
                                    <th>
                                        <i
                                            className="fa fa-question-circle"
                                            data-tip={tooltip}
                                            data-placement="bottom"
                                        />
                                    </th>
                                </tr>
                            </thead>
                            <tbody>{show ? tbody : null}</tbody>
                        </table>
                    </div>
                )}
                <ReactTooltip />
            </div>
        );
    }
}

export default (StationOdRank);
